import modal from './modal';
import {
  parseTime,
  staticUrl,
  staticUrl1,
  staticUrl2,
  staticUrl3,
  staticUrl4,
  staticUrl5,
  staticUrl6,
  staticUrl7,
  staticUrl8,
  staticUrl9,
  staticUrl10
} from '@/utils/u7buy';

import { App } from 'vue';
import Cookies from 'js-cookie';
export default function installPlugin(app: App) {
  // 模态框对象
  app.config.globalProperties.$modal = modal;
  app.config.globalProperties.parseTime = parseTime;
  app.config.globalProperties.staticUrl = staticUrl;
  app.config.globalProperties.staticUrl1 = staticUrl1;
  app.config.globalProperties.staticUrl2 = staticUrl2;
  app.config.globalProperties.staticUrl3 = staticUrl3;
  app.config.globalProperties.staticUrl4 = staticUrl4;
  app.config.globalProperties.staticUrl5 = staticUrl5;
  app.config.globalProperties.staticUrl6 = staticUrl6;
  app.config.globalProperties.staticUrl7 = staticUrl7;
  app.config.globalProperties.staticUrl8 = staticUrl8;
  app.config.globalProperties.staticUrl9 = staticUrl9;
  app.config.globalProperties.staticUrl0 = staticUrl10;
  app.config.globalProperties.$cookies = Cookies;
}
